import React from 'react';
import PropTypes from 'prop-types';

import Header from 'field/common/Header';
import Form from 'react-bootstrap/Form';

const BooleanEdit = ({ field }) => {
  // Only 1 value for booleans
  const checked = field.values[0] === true;

  const onKeyPress = e => {
    if (e.key === 'Enter') {
      field.setValue(0, !checked);
    }
  };

  return (
    <Form.Group controlId={field.predicate} className="field" >
      <Header field={field} />
      <Form.Control
        type='checkbox'
        disabled={field.disabled}
        index={0}
        onKeyPress={onKeyPress}
        checked={checked}
        onChange={e => field.setValue(0, !checked)}
      />
    </Form.Group>
  );
};

BooleanEdit.propTypes = {
  field: PropTypes.object.isRequired,
};

export default BooleanEdit;